/**
 * Concrete implementation of EditableLayerBase which supports creation of temporary drawings.
 */
import EditableLayerBase from "app/models/map/EditableLayerBase";
var WorkspaceLayer = EditableLayerBase.extend({
  attachLayer: function (map) {
    this._mapGraphics = map.graphics;

    return this._mapGraphics;
  },

  createMapLayer: function () {
    return this._mapGraphics;
  },

  createDataModel: function (geometryModel) {
    return geometryModel;
  },

  detach: function () {},

  _mapGraphics: null,
});

export default WorkspaceLayer;



//////////////////
// WEBPACK FOOTER
// ./public/js/app/models/map/WorkspaceLayer.js
// module id = 512
// module chunks = 1